import type {CodeListId} from 'services/codelists/types';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';
import type {Part} from '../types';

export const getPartCodelistId = (
  part: Part,
): Array<CodeListId | LinkedRoleCodeListId> | undefined => {
  switch (part.type) {
    case 'codelist': {
      return [part.codelistId];
    }
    case 'linkedAgent':
    case 'linkedLiterary': {
      return [part.roleCodelistId, 'UNNAMED_PERSON'];
    }
  }
  return undefined;
};
